<ngb-toast
    *ngFor="let toast of toasts()"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    [ngClass]="{ 'bg-success': !toast.failed, 'bg-danger': toast.failed }"
    class="text-light"
    (hide)="remove(toast)"
    >{{toast.body}}</ngb-toast>